import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ImagilityBaseResponse, ReferenceLibrary } from 'app-models';
import { filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { Observable, Subject, forkJoin, of } from 'rxjs';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { ActivatedRoute } from '@angular/router';
import { ApiServicesService } from '../../services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';

@Component({
  selector: 'app-employee-job-details',
  templateUrl: './employee-job-details.component.html',
  styleUrls: ['./employee-job-details.component.scss']
})
export class EmployeeJobDetailsComponent implements OnInit {

  employeeJobDetails: any;
  viewEdit: any;
  editDetails: boolean = false;
  empJobDetailsForm: FormGroup;
  employementTypeList: ReferenceLibrary[];
  observableSubscription$ = new Subject();
  fromFb: string;
  beneficiaryId;
  companyId;
  companyList = [];
  employeeList = [];
  hrEmployeeList = [];
  rmEmployeeList = [];
  departmentList = [];
  jobPositionList = [];
  shiftList: any = [];
  BGcheckEmailList: any = [];
  getAssetAllocationlist: any = [];
  getNoticePeriod: any = [];
  listCountry = [];
  listCompanyStates = [];
  listClientStates = [];
  isFBUser: boolean;
  // @Input() pageBuilderInfo;

  isFbHrManager: boolean;
  workLocationControls: any[];

  constructor(private empJobFormBuilder: FormBuilder,
    private route: ActivatedRoute, private apiService: ApiServicesService,
    private toastr: ToastrService, private authenticationService: AuthenticationService,
    private cacheCountryService: CacheCountryService,
    private changeDetectorRef: ChangeDetectorRef,) {

    this.cacheCountryService.getCachedCountryList()
      .pipe(take(1))
      .subscribe(data => {
        if (data.listCountries.length > 0) {
          this.listCountry = data.listCountries;
        }
      });

    // this.referenceLibraryService.getReferenceDataWithoutAuthentication('EMPTYPE').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
    //   this.employementTypeList = response;
    // });

    this.empJobDetailsForm = this.empJobFormBuilder.group({
      id: [''],
      employeeId: ['', Validators.required],
      companyDetails: this.empJobFormBuilder.group({
        companyId: ['', Validators.required],
        companyName: [''],
      }),
      //fbDepartmentId: ['', Validators.required],
      //fbShiftId: ['', Validators.required],
      jobProfile: ['', Validators.required],
      employeeTypeDetails: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      // location: ['', Validators.required],
      hireDate: ['', Validators.required],
      shiftDetails: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      noticePeriodDetails: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      compensation: ['', Validators.required],
      otherInstructions: ['', Validators.required],
      departmentDetails: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      jobPosition: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      bgCheckDetailsList: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      assetAllocationDetailsList: this.empJobFormBuilder.group({
        id: ['', Validators.required],
        name: [''],
      }),
      authorizationType: [''],
      linkedLca: [''],
      // reportManagerlocation: ['', Validators.required],
      reportingManagerDetails: this.empJobFormBuilder.group({
        employeeId: ['', Validators.required],
        employeeName: [''],
      }),
      hrManagerDetails: this.empJobFormBuilder.group({
        employeeId: ['', Validators.required],
        employeeName: [''],
      }),

      countryCode: this.empJobFormBuilder.group({
        countryCode: ['', Validators.required],
      }),
      stateProvinceCode: ['', Validators.required],
      stateProvinceName: ['', Validators.required],
      city: ['', Validators.required],
      workLocations: this.empJobFormBuilder.array([this.createLocation()]),
      // parentCompanyCountry: this.empJobFormBuilder.group({
      //   countryCode: ['', Validators.required],
      // }),
      // parentCompanyStateProvinceCode: [''],
      // parentCompanyStateProvinceName: [''],
      // parentCompanyCity: ['', Validators.required],
      // jobFamily: ['', Validators.required],
      // noticePeriodDate: ['', Validators.required],
      // originalHireDate: ['', Validators.required],
      // timeTaken: ['', Validators.required],
      // fte: ['', Validators.required],
      // workSpace: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.fromFb = this.route.snapshot.queryParams.pageFrom;
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    if (this.fromFb === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    }
    else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    if (this.companyId) {
      this.loadCompany_ddl();
      this.loadEmployeeList_ddl();
      this.loadJobPositionList();
      this.loadDepartment_ddl();
      this.loadShiftList();
      this.loadBGcheckEmailList();
      this.loadAssetAllocationlist();
      this.loadNoticePeriod();
      this.loadEmploymentTypeList();
    }/*
    if(this.companyId){
      this.loadShiftList();
    }else{
      this.getEmployeeJobDetails();
    } */
    this.getEmployeeJobDetails();
    try {
      // Check if 'isFBUser' exists in sessionStorage and set this.isFBUser accordingly
      this.isFBUser = sessionStorage.getItem('isFBUser') === 'true';
      this.isFbHrManager = !!this.authenticationService.currentUserValue && this.authenticationService.currentUserValue['permissions'].includes('FORMS_BUILDER_HR_MANAGER');
      // Set this.viewEdit based on 'userTypeRole' and this.isFBUser
      const userTypeRole = sessionStorage.getItem('userTypeRole');
      this.viewEdit = (userTypeRole !== 'Beneficiary' && !this.isFBUser) || (this.isFBUser && this.isFbHrManager);
    } catch (error) {
      // Set default values or handle the error as needed
      this.isFBUser = false;
      this.viewEdit = false;
      this.isFbHrManager = false;
    }

  }

  loadCompany_ddl() {
    this.apiService.getCompanyList_ddl(this.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.companyList = res;
    });
  }

  loadEmployeeList_ddl() {
    this.apiService.getEmployeeList_ddl(this.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.employeeList = res;
    });
  }

  loadHrEmployeeList_ddl() {
    this.apiService.getHrEmployeeList_ddl(this.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.hrEmployeeList = res;
    });
  }

  loadRmEmployeeList_ddl() {
    this.apiService.getRmEmployeeList_ddl(this.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.rmEmployeeList = res;
    });
  }

  loadDepartment_ddl() {
    this.apiService.getDepartmentList_ddl(this.companyId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.departmentList = res;
    });
  }

  loadShiftList() {
    this.apiService.getDataSourceList('FBSHIFTBYFBDEPTID').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.shiftList = res;
    });
  }
  loadBGcheckEmailList() {
    this.apiService.getDataSourceList('FB_ONB_BG_CHECK_SETUP').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.BGcheckEmailList = res;
    });
  }
  loadAssetAllocationlist() {
    this.apiService.getDataSourceList('FB_ONB_ASSET_ALLOC_SETUP').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.getAssetAllocationlist = res;
    });
  }
  loadNoticePeriod() {
    this.apiService.getDataSourceList('FB_ONB_NOTICE_PERIOD').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.getNoticePeriod = res;
    });
  }

  loadEmploymentTypeList() {
    this.apiService.getDataSourceList('LMSEMPLOYMENTTYPE').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.employementTypeList = res;
    });
  }

  loadJobPositionList() {
    this.apiService.getDataSourceList('FB_ONB_JOB_POSITION').pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      this.jobPositionList = res;
    });
  }

  createLocation(): FormGroup {
    return this.empJobFormBuilder.group({
      parentCompanyCountry: this.empJobFormBuilder.group({
        countryCode: ['', Validators.required],
      }),
      parentCompanyStateProvinceCode: [''],
      parentCompanyStateProvinceName: [''],
      parentCompanyCity: ['', Validators.required],
      listCompanyStates: [[]]
    });
  }

  get workLocations(): FormArray {
    return this.empJobDetailsForm.get('workLocations') as FormArray;
  }

  addLocation(): void {
    const locations = this.empJobDetailsForm.get('workLocations') as FormArray;
    locations.push(this.createLocation());
  }


  removeLocation(index: number): void {
    const locations = this.empJobDetailsForm.get('workLocations') as FormArray;
    locations.removeAt(index);
    if (this.employeeJobDetails && this.employeeJobDetails?.workLocations) {
      if (index < this.employeeJobDetails.workLocations.length) {
        this.employeeJobDetails.workLocations.splice(index, 1);
      }
    }
  }
  
  // handleDepartmentChange(e) {
  //   console.log(e.value);
  //   const departmentId = e.value;
  //   this.apiService.getShiftList_ddl(departmentId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
  //     this.shiftList = res;
  //   });
  // }

  getEmployeeJobDetails() {
    this.apiService.getEmployeeJobDetails(this.beneficiaryId)
      .pipe(
        takeUntil(this.observableSubscription$),
        filter((response: ImagilityBaseResponse) => response.status === 200),
        switchMap((response: ImagilityBaseResponse) => {
          this.employeeJobDetails = response.data;
          this.cacheCountryService.setCountryCode(this.employeeJobDetails?.parentCompanyCountry?.countryCode);
          const assetAllocationDetails = this.employeeJobDetails?.assetAllocationDetailsList || [];
          const bgCheckDetails = this.employeeJobDetails?.bgCheckDetailsList || [];

          const assetAllocationDetailsidList = assetAllocationDetails.map(element => element.assetAllocationId.toString());
          const assetAllocationDetailsnameList = assetAllocationDetails.map(element => element.emailId.toString());

          const bgCheckDetailsidList = bgCheckDetails.map(element => element.backGroundCheckId.toString());
          const bgCheckDetailsnameList = bgCheckDetails.map(element => element.emailId.toString());

          const countryCode = this.employeeJobDetails?.countryCode?.countryCode;
          // const parentCompanyCountryCode = this.employeeJobDetails?.parentCompanyCountry?.countryCode;
          const workLocations = this.employeeJobDetails.workLocations;

          const countryObservables: Observable<any>[] = [];
          if (workLocations?.length) {
            workLocations.forEach(workLocation => {
              const parentCompanyCountryCode = workLocation.parentCompanyCountry?.countryCode;
              if (parentCompanyCountryCode) {
                countryObservables.push(this.apiService.getStates(parentCompanyCountryCode));
              }
            });
          }

          const mainCountryObservable = countryCode && this.apiService.getStates(countryCode);

          const allObservables = [mainCountryObservable, ...countryObservables].filter(Boolean);

          // Added this condition to patch the employee ID for the migrated employee. As the countryObservables is empty, below this.patchFormValues function won't execute and hence the employeeId was showing blank
          if (allObservables.length == 0 && this.employeeJobDetails?.employeeId) {
            this.empJobDetailsForm.patchValue({
              employeeId: this.employeeJobDetails?.employeeId,
            })
          }
          const mainCountryStream = mainCountryObservable ? mainCountryObservable : of(null);
          const companyStatesObservable = countryObservables.length > 0 ? forkJoin(countryObservables): of([]);
          return forkJoin({
            clientStates: mainCountryStream,
            companyStates: companyStatesObservable
          })
          .pipe(
            map((responses: any) => {
              const { clientStates, companyStates } = responses;
              return { clientStates, companyStates, bgCheckDetailsidList, bgCheckDetailsnameList, assetAllocationDetailsidList, assetAllocationDetailsnameList };
            })
          );
          
        })
      )
      .pipe(take(1))
      .subscribe(({ clientStates, companyStates, bgCheckDetailsidList, bgCheckDetailsnameList, assetAllocationDetailsidList, assetAllocationDetailsnameList }) => {
        this.listClientStates = clientStates || null;
        companyStates.forEach((states, index) => {
          this.employeeJobDetails.workLocations[index].listCompanyStates = states;
        });

        this.updateFormValidators(
          this.empJobDetailsForm.get('stateProvinceName'),
          this.empJobDetailsForm.get('stateProvinceCode'),
          clientStates
        );
        // this.updateFormValidators(
        //   this.empJobDetailsForm.get('parentCompanyStateProvinceName'),
        //   this.empJobDetailsForm.get('parentCompanyStateProvinceCode'),
        //   companyStates
        // );
   
        if (this.employeeJobDetails.workLocations && this.employeeJobDetails.workLocations.length > 0) {
          const workLocationsArray = this.empJobDetailsForm.get('workLocations') as FormArray;
          workLocationsArray.controls.forEach((control: FormGroup, index: number) => {
            const workLocation = this.employeeJobDetails.workLocations[index];

            const parentCompanyStateProvinceCodeControl = control.get('parentCompanyStateProvinceCode');
            const parentCompanyStateProvinceNameControl = control.get('parentCompanyStateProvinceName');
            parentCompanyStateProvinceCodeControl.patchValue(workLocation.parentCompanyStateProvinceCode);
            parentCompanyStateProvinceNameControl.patchValue(workLocation.parentCompanyStateProvinceName);

            this.updateFormValidators(parentCompanyStateProvinceNameControl, parentCompanyStateProvinceCodeControl, companyStates);
          });
        }
        this.patchFormValues(bgCheckDetailsidList, bgCheckDetailsnameList, assetAllocationDetailsidList, assetAllocationDetailsnameList);

        this.changeDetectorRef.markForCheck();
      });
  }

  patchFormValues(bgCheckDetailsidList: any[], bgCheckDetailsnameList: any[], assetAllocationDetailsidList: any[], assetAllocationDetailsnameList: any[]) {

    const setNullable = (value: any) => (value ? value : null);
    const workLocationsArray = this.empJobDetailsForm.get('workLocations') as FormArray;
    workLocationsArray.clear(); 
    if (!(this.employeeJobDetails?.workLocations?.length > 0)) {
      this.addLocation();
    }
    if (this.employeeJobDetails && this.employeeJobDetails.workLocations) {
      this.employeeJobDetails.workLocations.forEach((workLocation: any) => {
        const parentCompanyCountryFormGroup = this.empJobFormBuilder.group({
          countryCode: [setNullable(workLocation.parentCompanyCountry?.countryCode)],
        });
        const locationFormGroup = this.empJobFormBuilder.group({
          parentCompanyCountry: parentCompanyCountryFormGroup,
          listCompanyStates: workLocation.listCompanyStates,
          parentCompanyStateProvinceCode: workLocation.listCompanyStates?.length > 0 ? setNullable(workLocation.parentCompanyStateProvinceCode) : null,
          parentCompanyStateProvinceName: !(workLocation.listCompanyStates?.length > 0) ? setNullable(workLocation.parentCompanyStateProvinceName) : null,
          parentCompanyCity: setNullable(workLocation.parentCompanyCity)
        });
        workLocationsArray.push(locationFormGroup);
      });
    }

    this.empJobDetailsForm.patchValue({
      employeeId: setNullable(this.employeeJobDetails?.employeeId),
      employeeTypeDetails: {
        id: setNullable(this.employeeJobDetails?.employeeTypeDetails?.employmentTypeId?.toString()),
        /* code: setNullable(this.employeeJobDetails?.employeeType?.code), */
        name: setNullable(this.employeeJobDetails?.employeeTypeDetails?.employmentTypeName),
      },
      shiftDetails: {
        id: setNullable(this.employeeJobDetails?.shiftDetails?.shiftId?.toString()),
        name: setNullable(this.employeeJobDetails?.shiftDetails?.shiftName),
      },
      noticePeriodDetails: {
        id: setNullable(this.employeeJobDetails?.noticePeriodDetails?.noticePeriodId?.toString()),
        name: setNullable(this.employeeJobDetails?.noticePeriodDetails?.noticePeriod),
      },
      departmentDetails: {
        id: setNullable(this.employeeJobDetails?.departmentDetails?.departmentId),
        name: setNullable(this.employeeJobDetails?.departmentDetails?.departmentName),
      },
      bgCheckDetailsList: {
        id: bgCheckDetailsidList,
        name: bgCheckDetailsnameList,
        // id: setNullable(this.employeeJobDetails?.bgCheckDetailsList?.backGroundCheckId?.toString()),
        // name: setNullable(this.employeeJobDetails?.bgCheckDetailsList?.emailId),
      },
      assetAllocationDetailsList: {
        // id: setNullable(this.employeeJobDetails?.assetAllocationDetailsList?.assetAllocationId?.toString()),
        id: assetAllocationDetailsidList,
        // name: setNullable(this.employeeJobDetails?.assetAllocationDetailsList?.emailId),
        name: assetAllocationDetailsnameList,
      },
      // reportManagerlocation: setNullable(this.employeeJobDetails?.reportManagerlocation),
      // location: setNullable(this.employeeJobDetails?.location),
      linkedLca: setNullable(this.employeeJobDetails?.linkedLca),
      jobProfile: setNullable(this.employeeJobDetails?.jobProfile),
      hireDate: this.employeeJobDetails?.hireDate ? moment(this.employeeJobDetails?.hireDate).format('MM/DD/YYYY') : null,
      compensation: setNullable(this.employeeJobDetails?.compensation),
      otherInstructions: setNullable(this.employeeJobDetails?.otherInstructions),
      authorizationType: setNullable(this.employeeJobDetails?.authorizationType),
      companyDetails: {
        companyId: setNullable(this.employeeJobDetails?.companyDetails?.companyId),
        companyName: setNullable(this.employeeJobDetails?.companyDetails?.companyName),
      },
      hrManagerDetails: {
        employeeId: setNullable(this.employeeJobDetails?.hrManagerDetails?.employeeId),
        employeeName: setNullable(this.employeeJobDetails?.hrManagerDetails?.employeeName),
      },
      reportingManagerDetails: {
        employeeId: setNullable(this.employeeJobDetails?.reportingManagerDetails?.employeeId),
        employeeName: setNullable(this.employeeJobDetails?.reportingManagerDetails?.employeeName),
      },
      /* fbDepartmentId: setNullable(this.employeeJobDetails?.fbDepartmentId), */
      //fbShiftId: setNullable(this.employeeJobDetails?.fbShiftId?.toString()),
      countryCode: {
        countryCode: setNullable(this.employeeJobDetails?.countryCode?.countryCode),
      },
      stateProvinceCode: this.listClientStates?.length > 0 ? setNullable(this.employeeJobDetails?.stateProvinceCode) : null,
      stateProvinceName: !(this.listClientStates?.length > 0) ? setNullable(this.employeeJobDetails?.stateProvinceName) : null,
      city: setNullable(this.employeeJobDetails?.city),
      workLocations: this.employeeJobDetails?.workLocations,
    //   parentCompanyCountry: {
    //     countryCode: setNullable(this.employeeJobDetails?.parentCompanyCountry?.countryCode),
    //   },
    //  parentCompanyStateProvinceCode: this.listCompanyStates?.length > 0 ? setNullable(this.employeeJobDetails?.parentCompanyStateProvinceCode) : null,
    //  parentCompanyStateProvinceName: !(this.listCompanyStates?.length > 0) ? setNullable(this.employeeJobDetails?.parentCompanyStateProvinceName) : null,
    //  parentCompanyCity: setNullable(this.employeeJobDetails?.parentCompanyCity),
      jobPosition: {
        id: setNullable(this.employeeJobDetails?.jobPositionId?.toString()),
        name: setNullable(this.employeeJobDetails?.position)
      },
    });
  }

  handleCountryChange(countryCode: string, stateIndex: 'company' | 'client', rowIndex: number) {
    this.cacheCountryService.setCountryCode(countryCode);
    this.apiService.getStates(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (stateIndex === 'company') {
          const parentCompanyStatesArray = this.empJobDetailsForm.get('workLocations') as FormArray;
          const control = parentCompanyStatesArray.at(rowIndex) as FormGroup;
          control.get('parentCompanyStateProvinceCode').setValue(''); 
          control.get('parentCompanyStateProvinceName').setValue('');
          control.setControl('listCompanyStates', this.empJobFormBuilder.array(states || []));

          this.updateFormValidators(
            control.get('parentCompanyStateProvinceName'),
            control.get('parentCompanyStateProvinceCode'),
            states
          );
        } else if (stateIndex === 'client') {
          this.updateFormValidators(
            this.empJobDetailsForm.get('stateProvinceName'),
            this.empJobDetailsForm.get('stateProvinceCode'),
            states
          );
          this.listClientStates = states || null;
        }
      });
  }

  private updateFormValidators(nameControl: AbstractControl, codeControl: AbstractControl, states: any[]) {
    if (!!states) {
      nameControl.clearValidators();
      codeControl.clearValidators();
      if (states.length > 0) {
        codeControl.setValidators([Validators.required]);
      } else {
        nameControl.setValidators([Validators.required]);
      }
      nameControl.updateValueAndValidity();
      codeControl.updateValueAndValidity();
      this.changeDetectorRef.markForCheck();
    }
  }

  saveEmpJobDetails() {
    // const tempdata = this.companyList.find(x => x.id === this.empJobDetailsForm.value['companyDetails']['companyId'])
    // tempdata.this.empJobDetailsForm.value['companyDetails']['companyName']
    let assetAllocationDetailsidList = this.empJobDetailsForm.value['assetAllocationDetailsList']['id'];
    const assetAllocationDetailsidListresult = this.getAssetAllocationlist.filter((data) => {
      return assetAllocationDetailsidList.some((dataItem) => {
        return (data.id ? data.id : data) == dataItem;
      });
    })
      .map((item) => {
        return { assetAllocationId: item.id, emailId: item.name };
      });
    let bgCheckDetailsList = this.empJobDetailsForm.value['bgCheckDetailsList']['id'];
    const bgCheckDetailsListresult = this.BGcheckEmailList.filter((data) => {
      return bgCheckDetailsList.some((dataItem) => {
        return (data.id ? data.id : data) == dataItem;
      });
    })
      .map((item) => {
        return { backGroundCheckId: item.id, emailId: item.name };
      });

    const workLocationsPayload = [];

    if (this.employeeJobDetails && this.employeeJobDetails.workLocations) {
      this.employeeJobDetails.workLocations.forEach((workLocation: any) => {
        const locationPayload = {
          id: workLocation.id,
          parentCompanyCountry: {
            countryCode: workLocation.parentCompanyCountry.countryCode,
          },
          parentCompanyStateProvinceCode: workLocation.parentCompanyStateProvinceCode,
          parentCompanyStateProvinceName: workLocation.parentCompanyStateProvinceName,
          parentCompanyCity: workLocation.parentCompanyCity
        };
        workLocationsPayload.push(locationPayload);
      });
    }
  
    const workLocationsArray = this.empJobDetailsForm.get('workLocations') as FormArray;
    workLocationsArray.controls.forEach((control: FormGroup, index: number) => {
      if (control.dirty || control.touched) {
        const locationPayload = {
          parentCompanyCountry: {
            countryCode: control.get('parentCompanyCountry').value.countryCode,
          },
          parentCompanyStateProvinceCode: control.get('parentCompanyStateProvinceCode').value,
          parentCompanyStateProvinceName: control.get('parentCompanyStateProvinceName').value,
          parentCompanyCity: control.get('parentCompanyCity').value
        };  
      if (this.employeeJobDetails && this.employeeJobDetails.workLocations && index < this.employeeJobDetails.workLocations.length) {
        workLocationsPayload[index] = {
          ...locationPayload,
          edited: true 
        };
      } else {
        workLocationsPayload.push(locationPayload);
      }
      
      }
    });

    const payload = {
      // ... this.empJobDetailsForm.value,
      id: this.employeeJobDetails.id,
      beneficaryId: this.beneficiaryId,
      hireDate: moment(this.empJobDetailsForm.get("hireDate")?.value).format('YYYY-MM-DD'),
      //shiftName: this.empJobDetailsForm.get("shiftName")?.value,
      compensation: this.empJobDetailsForm.get("compensation")?.value,
      otherInstructions: this.empJobDetailsForm.get("otherInstructions")?.value,
      //department: this.empJobDetailsForm.get("department")?.value,
      hrManagerDetails: {
        employeeId: this.empJobDetailsForm.value['hrManagerDetails']['employeeId'],
        employeeName: this.empJobDetailsForm.value['hrManagerDetails']['employeeFullName'],
      },
      reportingManagerDetails: {
        employeeId: this.empJobDetailsForm.value['reportingManagerDetails']['employeeId'],
        employeeName: this.empJobDetailsForm.value['reportingManagerDetails']['employeeFullName'],
      },
      employeeId: this.empJobDetailsForm.get("employeeId")?.value,
      companyDetails: {
        companyId: this.empJobDetailsForm.value['companyDetails']['companyId'],
        companyName: this.empJobDetailsForm.value['companyDetails']['companyName'],
      },
      jobProfile: this.empJobDetailsForm.get("jobProfile")?.value,
      employeeTypeDetails: {
        employmentTypeId: this.empJobDetailsForm.value['employeeTypeDetails']['id'],
        employmentTypeName: this.empJobDetailsForm.value['employeeTypeDetails']['name'],
        //isVisible: this.employeeJobDetails.employeeType.isVisible,
      },
      shiftDetails: {
        shiftId: this.empJobDetailsForm.value['shiftDetails']['id'],
        shiftName: this.empJobDetailsForm.value['shiftDetails']['name'],
      },
      noticePeriodDetails: {
        noticePeriodId: this.empJobDetailsForm.value['noticePeriodDetails']['id'],
        noticePeriod: this.empJobDetailsForm.value['noticePeriodDetails']['name'],
      },
      departmentDetails: {
        departmentId: this.empJobDetailsForm.value['departmentDetails']['id'],
        departmentName: this.empJobDetailsForm.value['departmentDetails']['name'],
      },
      bgCheckDetailsList: bgCheckDetailsListresult,
      // {
      //   backGroundCheckId: this.empJobDetailsForm.value['bgCheckDetailsList']['id'],
      //   emailId: this.empJobDetailsForm.value['bgCheckDetailsList']['name']
      // },
      assetAllocationDetailsList: assetAllocationDetailsidListresult,
      // {
      //   assetAllocationId: this.empJobDetailsForm.value['assetAllocationDetailsList']['id'],
      //   emailId: this.empJobDetailsForm.value['assetAllocationDetailsList']['name']
      // },
      // location: this.empJobDetailsForm.get("location")?.value,
      authorizationType: this.empJobDetailsForm.get("authorizationType")?.value,
      linkedLca: this.empJobDetailsForm.get("linkedLca")?.value,
      //fbDepartmentId: this.empJobDetailsForm.get("fbDepartmentId")?.value,
      //fbShiftId: this.empJobDetailsForm.get("fbShiftId")?.value,
      countryCode: {
        countryCode: this.empJobDetailsForm.value['countryCode']['countryCode'],
      },
      stateProvinceCode: this.empJobDetailsForm.get("stateProvinceCode")?.value,
      stateProvinceName: this.empJobDetailsForm.get("stateProvinceName")?.value,
      city: this.empJobDetailsForm.get("city")?.value,
      workLocations: workLocationsPayload,
      // parentCompanyCountry: {
      //   countryCode: this.empJobDetailsForm.value['parentCompanyCountry']['countryCode'],
      // },
      // parentCompanyStateProvinceCode: this.empJobDetailsForm.get("parentCompanyStateProvinceCode")?.value,
      // parentCompanyStateProvinceName: this.empJobDetailsForm.get("parentCompanyStateProvinceName")?.value,
      // parentCompanyCity: this.empJobDetailsForm.get("parentCompanyCity")?.value,

      // reportManagerlocation: this.empJobDetailsForm.get("reportManagerlocation")?.value,
      jobPositionId: parseInt(this.empJobDetailsForm.value['jobPosition']['id']),
      position: this.jobPositionList.find(e => e.id == this.empJobDetailsForm.value['jobPosition']['id']).name
    }
    this.apiService.saveEmployeeJobDetails(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((data: ImagilityBaseResponse) => {
      if (data.status === 200) {
        this.toastr.success(data.message, 'Success');
        this.getEmployeeJobDetails();
        this.editDetails = !this.editDetails;

      }
    })
    // this.empJobDetailsForm.disable();
  }

  handleEdit() {
    this.editDetails = !this.editDetails;
    this.empJobDetailsForm.enable();
    this.getEmployeeJobDetails();
    // if (this.employeeJobDetails.fbDepartmentId) {
    //   this.apiService.getShiftList_ddl(this.employeeJobDetails.fbDepartmentId).pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
    //     this.shiftList = res;
    //   });
    // }
    if (this.companyId) {
      this.loadCompany_ddl();
      this.loadEmployeeList_ddl();
      this.loadHrEmployeeList_ddl();
      this.loadRmEmployeeList_ddl();
      //this.loadShiftList();
    }
    // if (this.beneficiaryId) {

    // }
  }

  handleCancel(myForm) {
    this.empJobDetailsForm.disable();
    myForm.resetForm();
    this.editDetails = !this.editDetails;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

}
